import axios from 'axios';
import AuthenticationService from "../../services/AuthenticationService";
import redirectToAmbassador from "./redirectToAmbassador";

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 30000,
});

axiosConfig.interceptors.request.use(function (config) {
  const token = AuthenticationService.getLocalToken();
  config.headers.Authorization =  token ? `Bearer ${token}` : '';
  return config;
});

axiosConfig.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      redirectToAmbassador();
    }
    return Promise.reject(error);
  }
);

export default axiosConfig;
